const ReactReduxFirebaseConfig = {
    attachAuthIsReady: true,
    useFirestoreForProfile: true,
    userProfile: 'users' 
};

export default ReactReduxFirebaseConfig;